// extracted by mini-css-extract-plugin
module.exports = {"lifestageContainer":"lifestage-module--lifestageContainer--26E7y"};